import React from "react";

export function Logo({ size = 52, showText = false, variant = "dark", className = "" }) {
  // On light backgrounds show the full-color logo; on dark backgrounds invert to preserve visibility
  const style = variant === "light" ? { filter: "brightness(0) invert(1)" } : {};
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <img
        src="/logo-raunak.png"
        alt="Sarees by Raunak"
        style={{ height: size, width: "auto", ...style }}
        className="object-contain"
      />
      {showText && (
        <span className="sr-only">Sarees by Raunak</span>
      )}
    </div>
  );
}
